(function () {
    'use strict';
    $(() => {
        const $movie = $('.Movie');
        if ($movie.length) {
            $movie.find('.thumbnail').on('click', function () {
                const $iframe = $(this).siblings('.video').find('.yt-iframe');
                $iframe.attr('src', $iframe.data('src'));
                $(this).fadeOut(600, function () {
                    $(this).remove();
                })
            });
        }
    })
})();
